import * as React from 'react';
import { Datagrid, ListProps, NumberField, TextField } from 'react-admin';
import './OrganizationCoachNotificationDatagrid.scss';
import { TranslateField } from "../components/TranslateField";

export const OrganizationCoachNotificationDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="organization-coach-notifications-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<NumberField source="numberOfDaysSinceClientStart" label="NUMBER_OF_DAYS_SINCE_CLIENT_START"/>
			<TextField source="title" label="TITLE"/>
			<TextField source="body" label="BODY"/>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
